/** Platform operator permissions — separate from tenant (customer) permissions. */
const PLATFORM_PERMISSIONS = [
  { id: "platform.dashboard", label: "View platform dashboard" },
  { id: "platform.customers.read", label: "View system customers" },
  { id: "platform.customers.write", label: "Create and edit system customers" },
  {
    id: "platform.customer_modules",
    label: "Enable or disable customer modules",
  },
  { id: "platform.customer_users", label: "Manage customer users and invites" },
  { id: "platform.customer_billing", label: "Manage customer billing profile" },
  {
    id: "platform.impersonate",
    label: "Open customer workspace (act as customer)",
  },
  { id: "platform.operators", label: "Manage platform operators" },
  { id: "platform.roles", label: "Manage platform roles and permissions" },
];

const PLATFORM_ROLES = [
  {
    id: "platform_super_admin",
    label: "Platform super admin",
    description: "Full platform access including roles and operators",
    permissions: PLATFORM_PERMISSIONS.map((p) => p.id),
  },
  {
    id: "platform_support",
    label: "Platform support",
    description:
      "Customer care: users, modules, impersonation — no role matrix edits",
    permissions: [
      "platform.dashboard",
      "platform.customers.read",
      "platform.customers.write",
      "platform.customer_modules",
      "platform.customer_users",
      "platform.customer_billing",
      "platform.impersonate",
    ],
  },
];

const DEFAULT_PLATFORM_OPERATORS = [
  {
    id: "pop-001",
    name: "Anita Verma",
    email: "ops@developer-gps.example",
    roleId: "platform_super_admin",
    active: true,
  },
  {
    id: "pop-002",
    name: "Rohan Mehta",
    email: "support@developer-gps.example",
    roleId: "platform_support",
    active: true,
  },
];

function platformRoleHasPermission(roleId, permissionId) {
  const role = PLATFORM_ROLES.find((r) => r.id === roleId);
  return Boolean(role?.permissions.includes(permissionId));
}

export {
  DEFAULT_PLATFORM_OPERATORS,
  PLATFORM_PERMISSIONS,
  PLATFORM_ROLES,
  platformRoleHasPermission,
};
